import { CreateStocktakingsDto } from "../../../components/Pages/Documents/Warehouse/StockTakings/dtos/CreateStockTakingsDto";
import { IAppEntity } from "../../entities";
import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { StockTakingsService } from "../../../services/documents/StockTakingsService";
import { NFLookupStockTakings } from "../../../components/Shared/NewForms/NFLookupStockTakings";
import { SettlementVendorOpeningBalancesDetail } from "../../../components/Pages/Documents/SettlementVendorOpeningBalances/SettlementVendorOpeningBalancesDetail";
import SettlementVendorOpeningBalancesList from "../../../components/Pages/Documents/SettlementVendorOpeningBalances/SettlementVendorOpeningBalancesList";
import { NFLookupSettlementVendorOpeningBalances } from "../../../components/Shared/NewForms/NFLookupSettlementVendorOpeningBalances";
import { SettlementVendorOpeningBalancesService } from "../../../services/documents/SettlementVendorOpeningBalancesService";
import { CreateSettlementVendorOpeningBalancesDto } from "../../../dtos/documents/SettlementVendorOpeningBalances/CreateSettlementVendorOpeningBalancesDto";

export const SettlementVendorOpeningBalances: IAppEntity = {
  entityType: "document",
  title: "Settlement Vendor Opening Balances",
  pluralTitle: "Settlement Vendor Opening Balances",
  apiUrl: "SettlementVendorOpeningBalances",
  apiEnum: ReferenceTypes.DocumentSettlementVendorOpeningBalance,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(SettlementVendorOpeningBalancesDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(SettlementVendorOpeningBalancesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupSettlementVendorOpeningBalances, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new SettlementVendorOpeningBalancesService("SettlementVendorOpeningBalances"),
  getEmptyModel: () => {
    const model: CreateSettlementVendorOpeningBalancesDto = {
      status: 0,
      createdDate: new Date(),
      
      documentDate: new Date(),
      settlements:[]
    };
    return model;
  },
};
